"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PDF: 'application/pdf',
  MP4: 'video/mp4',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  BMP: 'image/bmp',
  EMBED: 'application/embed',
  EXTERNAL: 'application/external'
};
exports["default"] = _default;